import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { pageLoadLog } from './app/lib/page-load-debug';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
pageLoadLog('bootstrap start');
bootstrapApplication(AppComponent, appConfig)
  .then(() => pageLoadLog('bootstrap done'))
  .catch(err => console.error(err));
